
import { component } from '@/helpers/vueTyped';
import store from '@/store';
import { BackgroundOptions } from '@/store/navigation/types';
import ContentBackground from './ContentBackground.vue';
import HomeBackground from './HomeBackground.vue';
import LocalBackground from './LocalBackground.vue';


export default component()({
  name: 'BackgroundSwitcher',

  computed: {
    options(): BackgroundOptions {
      return store.state.background;
    },
  },

  render() {
    switch (this.options.type) {
      case 'content':
        return <ContentBackground imageURL={this.options.url} width={this.options.width}/>;
      case 'local':
        return <LocalBackground imageURL={this.options.url}/>;
      case 'home':
        return <HomeBackground imageURL={this.options.url}/>;
      default:
        return <div/>;
    }
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-041d52c1/BackgroundSwitcher.vue" });